import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=3f484b28"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"
import style0 from "./ModalForm.vue?vue&type=style&index=0&id=3f484b28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports